module.exports = "https://static.wmbcdn.com/uniweb/images/bfdd6e2b372c9e738e92a2e17fc5bcd5.svg";